<template>
    <footer>
        <div id="footer">
            <slot/>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer",
    }
</script>

<style lang="sass" scoped>
    footer
        background-color: $teal
        font-size: 150px
        font-weight: bold
        color: $dark
        text-align: center
        padding: 35vh 0

    @media screen and (max-width: $mobile-break-point)
        footer
            font-size: 70px
</style>